module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"selectActions":"Select Actions","selectActionsHint":"Select the actions you want this transition to trigger"},"fr":{"selectActions":"Choisir les actions","selectActionsHint":"Choisissez les actions que vous voulez déclencher dans cette transition"}}')
  delete Component.options._Ctor
}
